import { render, staticRenderFns } from "./MeusAcordos.vue?vue&type=template&id=5c588294&scoped=true"
import script from "./MeusAcordos.vue?vue&type=script&lang=js"
export * from "./MeusAcordos.vue?vue&type=script&lang=js"
import style0 from "./MeusAcordos.vue?vue&type=style&index=0&id=5c588294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c588294",
  null
  
)

export default component.exports